export default class MConfig
{
	static getRoutes()
	{
		return window._config.routes;
	}

	static getRoute(name)
	{
		return this.getRoutes()[name];
	}
}
